import { useLocation, useNavigate } from "react-router";

import { DiscoveryTitleSuggestionItem } from "../DiscoveryTittleSuggestion/DiscoveryTitleSuggestionItem";
import { Song } from "src/@types/api-types";
import { Container, ScrollableContainer } from "./DoubleColumnList.style";
import { useIntl } from "react-intl";
import { Typography } from "@mui/material";


export const DoubleColumnList = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const location = useLocation();
    const songs: Song[] = location.state?.data || [];

    if (songs.length === 0) {
        navigate(-1);
    }

    const goBack = () => {
        navigate(-1);
    };

    return (
        <Container>
            <Typography onClick={goBack} style={{ cursor: 'pointer' }} mb={4}>{intl.formatMessage({ id: "navigation.back" })}</Typography>
            <Typography fontSize={18} fontWeight={'bold'} mb={2}>{intl.formatMessage({ id: "song.songs" })}</Typography>
            <ScrollableContainer vertical nativeMobileScroll hideScrollbars>
                {songs.map((song) => (
                    <DiscoveryTitleSuggestionItem key={song.id} song={song} />
                ))}
            </ScrollableContainer>
        </Container>
    );
}